import * as R from "ramda";
import React, { Component } from "react";
import FlexView from "react-flexview";
import Button from "../../../../../modules/commons/Button";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import SimplePrintButton from "../../../../../modules/SimplePrintButton";
import SimpleDataTable from "../../../../../modules/SimpleDataTable";
import SimpleDate from "../../../../../modules/SimpleDate";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import {
  formGroupReceivingOtherItems,
  modalContentConfig,
  tabTableConfig,
} from "../config/config";
import ReceivingCreateUpdate from "./receivingCreateUpdate";
import ReceivingDetail from "./receivingDetail";
import ReceivingFilter from "./receivingFilter";
import {
  flattenFormGroupObject,
  getValueFromDDL,
  mapToObjectDDL,
  removeNullFields,
} from "../../../../common/mapper";
import M from "moment/moment";
import Api from "../../../../../Services/Api";
import { defaultTableChange } from "../../../../../modules/custom/customTable";
import SimpleAlert from "../../../../../modules/popup/SimpleAlert";
import {
  contructQueryParam,
  getUserAccess,
} from "../../../../../Services/Utils";
import SimplePrintTable from "../../../../../modules/popup/SimplePrintTable";
import SimpleLoadingOverlay from "../../../../../modules/popup/SimpleLoadingOverlay";
import { connect } from "react-redux";
import { HttpStatus } from "../../../../common/Constants";
import ErrorAction from "../../../../../Redux/ErrorRedux";
import { saveAs } from "file-saver";

class ReceivingContent extends Component {
  constructor(props) {
    super(props);
    this.tabTableConfig = tabTableConfig[props.tab];
    this.tableColumns = [
      {
        name: "id",
        label: "No",
        options: {
          customBodyRender: (_, tableMeta) => {
                const {page, rowsPerPage} = tableMeta.tableState;
                const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

                return <>{rowNumber}</>;
            },
          sort: false,
        },
      },
      {
        name: "spblDate",
        label: "Tanggal SPBL",
        options: {
          sort: false,
        },
      },
      {
        name: "spblNo",
        label: "No. SPBL",
        options: {
          sort: false,
        },
      },
      {
        name: "spbmNo",
        label: "No. SPBM",
        options: {
          sort: false,
        },
      },
      {
        name: "spbmDate",
        label: "Tanggal SPBM",
        options: {
          sort: false,
        },
      },
      {
        name: "total",
        label: "Jumlah",
        options: {
          sort: false,
        },
      },
      {
        name: "note",
        label: "Catatan",
        options: {
          sort: false,
        },
      },
      {
        name: "",
        label: "Aksi",
        options: {
          customBodyRender: (_, tableMeta) => {
            return (
              <Button
                className="btnAct"
                onClick={() =>
                  this.handleModalDetailVisibility(tableMeta.rowIndex)
                }
              >
                <i
                  className="fa fa-lg fa-eye"
                  style={{
                    fontSize: 20,
                    color: "red",
                  }}
                />
              </Button>
            );
          },
          sort: false,
        },
      },
    ];
    this.initialSearch = {
      startSpblDate: null,
      endSpblDate: null,
    };
    this.initialFilterData = {
      startSpblDate: null,
      endSpblDate: null,
      startSpbmDate: null,
      endSpbmDate: null,
      spblNo: null,
      spbmNo: null,
      otherItemCode: null,
      otherItemCategory: null,
      kodeLocator: null,
    };
    this.state = {
      userAccess: null,
      loading: false,
      alertSavedModalVisible: false,
      modalCreateDataVisible: false,
      filterModalVisible: false,
      detailModalVisible: false,
      printModalVisible: false,
      alertValidationModalVisible: false,
      isFiltered: false,
      selectedData: null,
      selectedCabang: null,
      fetchingTableData: false,
      search: this.initialSearch,
      filterData: this.initialFilterData,
      dataCabang: [],
      dataTable: [],
      pagination: {
        count: 10,
        limit: 5,
        page: 1,
        orderBy: "id",
        sort: "ASC",
      },
    };
  }

  async componentDidMount() {
    this.setState((prevState) => ({
      ...prevState,
      search: {
        startSpblDate: M(new Date()).format("DD-MM-YYYY"),
        endSpblDate: M(new Date()).format("DD-MM-YYYY"),
      },
    }));
    await this.fetchDataCabang();
    await this.initialFetchData();
  }

  initialFetchData = async (page) => {
    await this.fetchData({
      ...removeNullFields(this.parseFilterData(this.state.search)),
      limit: this.state.pagination.limit,
      page: page ?? 1,
    });
  };

  handleChangeKodeCabang = async (kodeCabang) => {
    this.handleTriggerLoading();
    await this.setState((prevState) => ({
      ...prevState,
      pagination:{
        ...prevState.pagination, page: 1, limit: 5
      }
    }));

    await this.fetchData({
      kodeCabang,
      startSpblDate: M().format("DD-MM-YYYY"),
      endSpblDate: M().format("DD-MM-YYYY"),
      limit: this.state.pagination.limit,
      page: 1,
    });

    this.setState((prevState) => {
      const selectedCabang = prevState.dataCabang.find(
        (c) => c.kodeCabang === kodeCabang
      );
      return {
        ...prevState,
        userAccess: getUserAccess(this.props.menuAccess, kodeCabang),
        search: {
          ...prevState.search,
          kodeCabang: mapToObjectDDL(selectedCabang?.namaDealer, kodeCabang),
          startSpblDate: M().format("DD-MM-YYYY"),
          endSpblDate: M().format("DD-MM-YYYY"),
        },
      };
    });

    this.handleTriggerLoading();
  };

  handleModalFilterVisibility = () => {
    this.setState((prevState) => ({
      ...prevState,
      selectedCabang: this.state.search.kodeCabang,
      filterModalVisible: !prevState.filterModalVisible,
    }));
  };

  handleModalDetailVisibility = (index) => {
    if (!R.isNil(index)) {
      const dataTableState = [...this.state.dataTable];
      const selectedData = dataTableState[index];
      this.setState((prevState) => ({
        ...prevState,
        selectedData,
        selectedCabang: this.state.search.kodeCabang,
        detailModalVisible: !prevState.detailModalVisible,
      }));
      return;
    }

    this.setState((prevState) => ({
      ...prevState,
      selectedData: null,
      detailModalVisible: !prevState.detailModalVisible,
    }));
  };

  handleModalCreateVisibility = () => {
    this.setState((prevState) => ({
      ...prevState,
      selectedCabang: this.state.search.kodeCabang,
      modalCreateDataVisible: !prevState.modalCreateDataVisible,
    }));
  };

  handleAlertSavedModalVisibility = () => {
    this.setState((prevState) => ({
      ...prevState,
      alertSavedModalVisible: !prevState.alertSavedModalVisible,
    }));
  };

  handleInputDateChange = (name, value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      search: {
        ...prevValue.search,
        [name]: M(value).format("DD-MM-YYYY"),
      },
    }));
  };

  handleSearchValueChange = (name, value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      search: {
        ...prevValue.search,
        [name]: value,
      },
    }));
    if (R.equals(name, "kodeCabang")) this.handleChangeKodeCabang(value.value);
  };

  handleFilterValueChange = (name, value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      filterData: {
        ...prevValue.filterData,
        [name]: value,
      },
    }));
  };

  handleOnSubmitSearch = async () => {
    try {
      this.handleTriggerLoading();
      this.setState((prevValue) => ({
        ...prevValue,
        pagination: { ...prevValue.pagination, page: 1 },
      }));
      await this.fetchData({
        ...removeNullFields(this.parseFilterData(this.state.search)),
        limit: this.state.pagination.limit,
        page: 1,
      });
      this.handleClearFilter();
      this.handleTriggerLoading();
    } catch (error) {
      console.log("errors: ", error);
    }
  };

  handleSubmitFilter = async () => {
    const { filterData, search, pagination } = this.state;

    // Normalisasi data filter
    const requestBody = {
      kodeCabang: search?.kodeCabang?.value || null,
      spblNo: filterData.spblNo || null,
      startSpblDate: filterData.startSpblDate || null,
      endSpblDate: filterData.endSpblDate || null,
      spbmNo: filterData.spbmNo || null,
      startSpbmDate: filterData.startSpbmDate || null,
      endSpbmDate: filterData.endSpbmDate || null,
      otherItemCode: filterData.otherItemCode?.value || null,
      otherItemCategory: filterData.otherItemCategory?.value || null,
      kodeLocator: filterData.kodeLocator?.value || null,
      limit: pagination?.limit || 1,
      page: 1,
    };

    try {
      this.handleTriggerLoading();
      await this.fetchData(removeNullFields(requestBody));
      this.setState({ isFiltered: true });
    } catch (error) {
      console.log("error:", error);
    } finally {
      this.handleTriggerLoading();
      this.handleClearSearch();
      this.handleModalFilterVisibility();
    }
  };

  handleClearFilter = () => {
    this.setState((prevState) => ({
      ...prevState,
      filterData: { ...this.initialFilterData },
      isFiltered: false,
    }));
  };

  handleClearSearch = () => {
    this.setState((prevState) => ({
      ...prevState,
      search: {
        ...prevState.search,
        ...this.initialSearch,
      },
    }));
  };

  handleOnSubmit = async (action, data, list) => {
    const adjustedList = list.map((item) => ({
      ...item,
      id: action === "save" ? null : item.id,
    }));

    if (!adjustedList || adjustedList.length === 0) {
      this.handleAlertValidationVisibility(
        "Terdapat data yang belum lengkap, mohon periksa kembali"
      );
      return; 
    }

    try {
      this.handleTriggerLoading();

      const formGroup = flattenFormGroupObject(data);
      const requestBody = {
        ...formGroup,
        listReceivingDetail: adjustedList,
        idSupplier: getValueFromDDL(formGroup, "idSupplier"),
        idSupplierExpedisi: getValueFromDDL(formGroup, "idSupplierExpedisi"),
        kodeCabang: getValueFromDDL(formGroup, "kodeCabang"),
        id: action === "save" ? null : data.id.value,
      };

      const res = await Api.create(
        "NAGAMAS_TRANSACTION"
      ).submitReceivingOtherItem(requestBody);

      if (res.ok && res.data.status === HttpStatus.SUCCESS) {
        if (action === "save") {
          this.handleModalCreateVisibility();
        } else {
          this.handleModalDetailVisibility();
        }

        // await this.fetchData({
        //   ...removeNullFields(this.parseFilterData(this.state.search)),
        //   limit: this.state.pagination.limit,
        //   page: 1,
        // });
        await this.handleRefetchAfterProcess()

        this.handleAlertSavedModalVisibility();
      }
    } catch (error) {
      console.log("errors: ", error);
    } finally {
      this.handleTriggerLoading();
    }
  };

  handleOnDelete = async (param) => {
    try {
      this.handleTriggerLoading();
      await Api.create("NAGAMAS_TRANSACTION").deleteReceivingOtherItem(
        contructQueryParam({
          spblNo: param,
        })
      );
      // await this.fetchData({
      //   ...removeNullFields(this.parseFilterData(this.state.search)),
      //   limit: this.state.pagination.limit,
      //   page: 1,
      // });
      await this.handleRefetchAfterProcess()
      this.handleModalDetailVisibility();
      this.handleTriggerLoading();
    } catch (error) {
      console.log("errors: ", error);
    }
  };

  handlePrint = async () => {
    this.handleTriggerLoading();
    const { filterData, search, pagination } = this.state;
    const requestBody = {
      kodeCabang: search?.kodeCabang?.value || null,
      spblNo: filterData.spblNo || null,
      startSpblDate: filterData.startSpblDate || null,
      endSpblDate: filterData.endSpblDate || null,
      spbmNo: filterData.spbmNo || null,
      startSpbmDate: filterData.startSpbmDate || null,
      endSpbmDate: filterData.endSpbmDate || null,
      otherItemCode: filterData.otherItemCode?.value || null,
      otherItemCategory: filterData.otherItemCategory?.value || null,
      kodeLocator: filterData.kodeLocator?.value || null,
      limit: null,
      page: null,
    };
    try {
      const res = await Api.create(
        "NAGAMAS_TRANSACTION_FILE"
      ).downloadReceivingItemsExcel(requestBody);
      if (res.ok) {
        const blob = new Blob([res.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        saveAs(blob, "RECEIVING_ITEMS.xlsx");
      }
    } catch (error) {
      console.log(error);
    }
    this.handleTriggerLoading();
  };

  handleChangePage = async (tableState) => {
    this.handleTriggerLoading();
    const limit = tableState.rowsPerPage;
    const page = tableState.page + 1;

    this.setState((prevValue) => ({
      ...prevValue,
      pagination: { ...prevValue.pagination, page, limit },
    }));

    if (!this.state.isFiltered) {
      // 👇 Jika belum pernah filter, pakai initialFetchData
      await this.initialFetchData(page);
    } else {
      // 👇 Jika sudah filter, gunakan filterData
      const filterRequest = removeNullFields(
        this.parseFilterData(this.state.filterData)
      );
      await this.fetchData({
        ...filterRequest,
        kodeCabang: this.state.search.kodeCabang.value,
        page,
        limit,
      });
    }

    this.handleTriggerLoading();
  };

  handleChangeRowsPerPage = async (tableState) => {
    this.handleTriggerLoading();
    const limit = tableState.rowsPerPage;

    await this.setState((prevValue) => ({
      ...prevValue,
      pagination: { ...prevValue.pagination, count: 1, page: 1, limit },
    }));

    if (!this.state.isFiltered) {
      await this.initialFetchData();
    } else {
      const filterRequest = removeNullFields(
        this.parseFilterData(this.state.filterData)
      );
      await this.fetchData({
        ...filterRequest,
        kodeCabang: this.state.search.kodeCabang.value,
        page: 1,
        limit,
      });
    }

    this.handleTriggerLoading();
  };

  handleTriggerLoading = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      loading: !prevValue.loading,
    }));
  };

  fetchData = async (body) => {
    try {
      let res = await Api.create(
        "NAGAMAS_TRANSACTION"
      ).getMainPageReceivingOtherItem(
        body && Object.keys(body).length > 0 ? body : { page: 1, limit: 5 }
      );

      if (res.ok) {
        this.setState((prevValue) => ({
          ...prevValue,
          dataTable: res.data.data,
          pagination: {
            ...prevValue.pagination,
            count: res.data.totalData,
          },
          userAccess: getUserAccess(
            this.props.menuAccess,
            this.state.search?.kodeCabang?.value
          ),
        }));
      }
    } catch (e) {
      console.log("errors: ", e);
    }
  };

  fetchDataCabang = async () => {
    try {
      let res = await Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang();
      if (res.ok) {
        let filteredData = res.data.data.filter((item) =>
          this.props.menuAccess
            ?.map((data) => data.idRefObj)
            .includes(item.kodeCabang)
        );
        if (filteredData.length !== 0) {
          this.setState((prevValue) => ({
            ...prevValue,
            dataCabang: filteredData,
            search: {
              ...prevValue.search,
              kodeCabang: mapToObjectDDL(
                filteredData[0].namaDealer,
                filteredData[0].kodeCabang
              ),
            },
          }));
        }
      }
    } catch (error) {
      console.log("errors: ", error);
    }
  };

  parseFilterData(data) {
    return {
      ...data,
      kodeCabang: getValueFromDDL(data, "kodeCabang"),
      otherItemCode: getValueFromDDL(data, "otherItemCode"),
      otherItemCategory: getValueFromDDL(data, "otherItemCategory"),
      kodeLocator: getValueFromDDL(data, "kodeLocator"),
    };
  }

  handleAlertValidationVisibility = (text) => {
    this.setState((prevState) => ({
      ...prevState,
      warningMessage: text,
      alertValidationModalVisible: !prevState.alertValidationModalVisible,
    }));
  };

  handleRefetchAfterProcess = async () => {
    if (!this.state.isFiltered) {
      await this.initialFetchData(this.state.pagination.page);
    } else {
      const filterRequest = removeNullFields(
        this.parseFilterData(this.state.filterData)
      );
      await this.fetchData({
        ...filterRequest,
        kodeCabang: this.state.search.kodeCabang.value,
        page: this.state.pagination.page,
        limit: this.state.pagination.limit,
      });
    }
  }

  render() {
    return (
      <>
        <FlexView
          style={{ justifyContent: "space-between" }}
          vAlignContent="center"
          className="margin-top-5px"
        >
          <FlexView vAlignContent="center" style={{ gap: "10px" }}>
            <SimpleDDL
              id="select_options_nama_cabang"
              box="search"
              name="kodeCabang"
              containerclassname="width width-250px"
              placeholder="Nama Cabang"
              menuPosition="fixed"
              options={this.state.dataCabang.map((item) =>
                mapToObjectDDL(item.namaDealer, item.kodeCabang)
              )}
              value={this.state.search.kodeCabang}
              onChange={(value, { name }) =>
                this.handleSearchValueChange(name, value)
              }
            />
            <SimpleDate
              id="select_date_from"
              nextdate
              date={this.state.search.startSpblDate}
              maxDate={this.state.search.endSpblDate}
              onChange={(value) =>
                this.handleInputDateChange("startSpblDate", value)
              }
            />
            <SimpleDate
              id="select_date_to"
              date={this.state.search.endSpblDate}
              onChange={(value) =>
                this.handleInputDateChange("endSpblDate", value)
              }
            />
            <SimpleButton
              text="Cari"
              className="margin-bottom-20px"
              onClick={this.handleOnSubmitSearch}
            />
          </FlexView>
          <SimpleButton
            className={"btn background-red margin-bottom-20px"}
            styles={{ width: "unset" }}
            onClick={this.handleModalFilterVisibility}
            icon={<i className="fa fa-qrcode"></i>}
          />
        </FlexView>
        <SimpleDataTable
          data={this.state.dataTable}
          columns={this.tableColumns}
          options={{
            ...defaultTableChange(
              (tableState) => this.handleChangePage(tableState),
              (tableState) => this.handleChangeRowsPerPage(tableState)
            ),
          }}
          toCount={this.state.pagination.count}
          rowsPerPage={this.state.pagination.limit}
          page={this.state.pagination.page - 1}
          footerAdditionalButtons={
            <FlexView hAlignContent={"right"}>
              {this.state.userAccess && this.state.userAccess.createAccess && (
                <SimpleButton
                  onClick={() => this.handleModalCreateVisibility()}
                  icon={<i className="fa fa-plus margin-right-10px"></i>}
                  text={"Tambah Data"}
                />
              )}
              {/* <SimplePrintButton
                text="Cetak"
                toPdf
                toExcel
                onPrint={(value) => this.handlePrint(value)}
              /> */}
              <SimpleButton
                onClick={() => this.handlePrint()}
                icon={<i className="fa fa-lw fa-print margin-right-10px"></i>}
                text={"Print"}
              />
            </FlexView>
          }
        />

        {this.state.modalCreateDataVisible && (
          <ReceivingCreateUpdate
            tab={this.props.tab}
            contentConfig={modalContentConfig[this.props.tab]}
            formGroup={formGroupReceivingOtherItems}
            initialValues={this.state.selectedData}
            selectedCabang={this.state.selectedCabang}
            visible={this.state.modalCreateDataVisible}
            onSubmit={this.handleOnSubmit}
            onClickClose={this.handleModalCreateVisibility}
          />
        )}

        {this.state.filterModalVisible && (
          <ReceivingFilter
            tab={this.props.tab}
            selectedCabang={this.state.selectedCabang}
            filteredData={this.state.filterData}
            visible={this.state.filterModalVisible}
            onClearFilter={this.handleClearFilter}
            onValueChange={this.handleFilterValueChange}
            onSubmit={this.handleSubmitFilter}
            onClickClose={this.handleModalFilterVisibility}
          />
        )}

        {this.state.detailModalVisible && (
          <ReceivingDetail
            tab={this.props.tab}
            formGroup={formGroupReceivingOtherItems}
            initialValues={this.state.selectedData}
            selectedCabang={this.state.selectedCabang}
            userAccess={this.state.userAccess}
            visible={this.state.detailModalVisible}
            tableConfig={this.tabTableConfig}
            onSubmit={this.handleOnSubmit}
            onDelete={this.handleOnDelete}
            onClickClose={this.handleModalDetailVisibility}
          />
        )}

        {this.state.alertSavedModalVisible && (
          <SimpleAlert
            title={"Information"}
            content={"Data telah disimpan."}
            visible={this.state.alertSavedModalVisible}
            onClickClose={this.handleAlertSavedModalVisibility}
            additionalButtons={
              <SimpleButton
                type="button"
                text="OK"
                onClick={() => this.handleAlertSavedModalVisibility()}
              />
            }
          />
        )}

        {this.state.alertValidationModalVisible && (
          <SimpleAlert
            title={"Information"}
            content={
              <div>
                <p>{this.state.warningMessage}</p>
              </div>
            }
            visible={this.state.alertValidationModalVisible}
            onClickClose={this.handleAlertValidationVisibility}
            additionalButtons={
              <FlexView style={{ gap: "15px" }}>
                <SimpleButton
                  className="margin-left-none"
                  type="button"
                  text="OK"
                  onClick={() => this.handleAlertValidationVisibility()}
                />
              </FlexView>
            }
          />
        )}

        {this.state.printModalVisible && (
          <SimplePrintTable onClearPrint={this.handlePrint} />
        )}
        <SimpleLoadingOverlay active={this.state.loading} />
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setError: (payload) => dispatch(ErrorAction.setError(payload)),
  };
};

export default connect(null, mapDispatchToProps)(ReceivingContent);
